import { ActionTree } from 'vuex';
import axios from 'axios';
import animations from '../animations';

const animationsAsObject = {
    ava_gesture_talk_01: { file: "ava_gesture_talk_01", length: 4020, group: "" },
    ava_gesture_talk_02: { file: "ava_gesture_talk_02", length: 3050, group: "" },
    ava_gesture_talk_03: { file: "ava_gesture_talk_03", length: 3000, group: "" },
    ava_gesture_talk_04: { file: "ava_gesture_talk_04", length: 4020, group: "" },
    ava_gesture_talk_05: { file: "ava_gesture_talk_05", length: 2090, group: "" },
    ava_gesture_talk_06: { file: "ava_gesture_talk_06", length: 3000, group: "" },
    ava_gesture_talk_07: { file: "ava_gesture_talk_07", length: 4040, group: "" },
    ava_gesture_talk_08: { file: "ava_gesture_talk_08", length: 3020, group: "" },
    ava_gesture_talk_09: { file: "ava_gesture_talk_09", length: 4060, group: "" },
    ava_idle_notalk_01: { file: "ava_idle_notalk_01", length: 2090, group: "" },
    ava_idle_talk_01: { file: "ava_idle_talk_01", length: 1000, group: "" },
    ava_turn_talk_01: { file: "ava_turn_talk_01", length: 3020, group: "" },
    ava_turn_talk_02: { file: "ava_turn_talk_02", length: 3060, group: "" },
    ava_turn_talk_03: { file: "ava_turn_talk_03", length: 3060, group: "" },
    ava_turn_talk_04: { file: "ava_turn_talk_04", length: 4020, group: "" }
}
let animationTimer;

export const actions = {
    playAnimations({ commit, state, rootState }, animationKeys) {
        let i = 0;
        let x = 1;
        let animation = animationsAsObject[animationKeys[0]];
        commit('setCurrentAnimation', animation.file);
        if (animationKeys.length > 1) {
            stopAnimationTimer();
            startAnimationTimer(animation.length);
        }

        function startAnimationTimer(length) {
            animationTimer = setTimeout(function () {
                let nextAnimation = animationsAsObject[animationKeys[x]];
                commit('setCurrentAnimation', nextAnimation.file);
                x++;
                i++;
                if (x < animationKeys.length) {
                    let currentAnimation = animationsAsObject[animationKeys[i]];
                    startAnimationTimer(currentAnimation.length);
                }
            }, length);
        }
        function stopAnimationTimer() {
            clearTimeout(animationTimer);
        }
    }
 };